<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">{{title}}</v-card-title>

    <v-card-text>

        <div>
            <v-chip
                v-for="(item, index) in value"
                :key="index"
                style="margin-right: 5px; margin-bottom: 5px;"
                close
                @click:close="value.splice(index, 1)"
            >
                {{item.text}}
            </v-chip>
        </div>

        <v-text-field
            ref="search"
            v-model="search"
            full-width
            hide-details
            label="Search"
            autocomplete="off"
          >
          <v-icon 
                slot="append" 
                style="pointer-events: auto;"
            >
                mdi-magnify
            </v-icon>

        </v-text-field>

        <v-divider/>
        <v-list>
            <template v-for="(item,index) in possible_values">
                <v-list-item
                    :key="index"
                    @click="addItem(item)"
                    v-show="showPossibleValue(item)"
                >
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item>
            </template>
        </v-list>


    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const _ = require('lodash');

export default {
    props: {
        title: {
            type: String,
            default: function () { return 'Edit Time Interval'; }
        },

        possible_values: {
            type: Array,
            default: function () { return []; }
        },
    },

    data() {
        return {
            dialog: false,
            search: null,
            value: [],
        }
    },

    methods: {
        showDialog(value) 
        {
            this.value = _.cloneDeep(value);
             this.dialog = true; 
        },
        
        onOk()
        {
           this.dialog = false;

            this.$emit('ok',this.value);
        },

        addItem(item)
        {
            this.value.push(item);
        },

        showPossibleValue(possible_value)
        {
            let search = this.normSearch();

            if ( search != null )
            {
                let text = possible_value.text.toLowerCase();
                if ( !text.includes(search) ) 
                    return false;
            }

            for ( let i = 0; i < this.value.length; i++ )
            {
                if ( _.isEqual(possible_value, this.value[i]) )
                    return false;
            }

            return true;
        },

        normSearch()
        {
            if ( this.search == null ) return null;
            return this.search.trim().toLowerCase();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>